// src/components/Preloader.jsx

import React from "react";
import MKBox from "components/MKBox";
import logo from "assets/Images/logo.png"; // your transparent logo

export default function Preloader() {
  return (
    <MKBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100vh"
      bgcolor="white"
      zIndex={9999}
    >
      <MKBox
        component="img"
        src={logo}
        alt="Loading..."
        sx={{
          width: 750,
          height: 750,
          animation: "pulse 1.5s ease-in-out infinite",
        }}
      />

      {/* Add animation keyframes inline */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.1); opacity: 0.8; }
            100% { transform: scale(1); opacity: 1; }
          }
        `}
      </style>
    </MKBox>
  );
}
